import Cookies from "js-cookie";


export var headers = {
    "Content-type": "application/json",
    "Authorization": "bearer " + (Cookies.get('auth-token') ? Cookies.get('auth-token') : "")
}